import { FieldValue, Timestamp } from "firebase/firestore";
import getB from "../../utils/bridges/EkaBridge";
import { getMe } from "../../utils/bridges/methods";
import { isoStringToTimestamp } from "../../firestore/utils";

const makeFirestoreTTL_For6months = () => {
  const sixMonthsFromNow = new Date();
  sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);
  return getB().firestore.Timestamp.fromDate(sixMonthsFromNow);
  // const twoMinutesFromNow = new Date();
  // twoMinutesFromNow.setMinutes(twoMinutesFromNow.getMinutes() + 5);
  // return getB().firestore.Timestamp.fromDate(twoMinutesFromNow);
};

export interface firestoreAppointmentActivityDataObject {
  created_at: Timestamp | FieldValue;
  event: AptActivityType;
  actor_name: string;
  actor_id: string;
  actor_role: Actor;
  client_id: SourcePlatform;
  expires_at: Timestamp; // this will the TTL
}

enum WhiteListedActivityTypeEnums {
  CREATED = "CREATED",
  // VISIT_STARTED = "VISIT_STARTED",
  VISIT_CHECKED_IN = "VISIT_CHECKED_IN",
  VISIT_RESCHEDULED = "VISIT_RESCHEDULED",
  VISIT_CANCELLED = "VISIT_CANCELLED",
  VISIT_ENDED = "VISIT_ENDED",
  RESCHEDULE_CREATED = "RESCHEDULE_CREATED",
  MARKED_NOSHOW = "MARKED_NOSHOW",
  VISIT_ARCHIVED = "VISIT_ARCHIVED",
}

const whiteListedActivityTypes: Set<string> = new Set([
  WhiteListedActivityTypeEnums.VISIT_CANCELLED,
  // WhiteListedActivityTypeEnums.VISIT_STARTED,
  WhiteListedActivityTypeEnums.CREATED,
  WhiteListedActivityTypeEnums.VISIT_RESCHEDULED,
  WhiteListedActivityTypeEnums.VISIT_ENDED,
  WhiteListedActivityTypeEnums.VISIT_CHECKED_IN,
  WhiteListedActivityTypeEnums.RESCHEDULE_CREATED,
  WhiteListedActivityTypeEnums.MARKED_NOSHOW,
  WhiteListedActivityTypeEnums.VISIT_ARCHIVED,
]);

export async function trackAppointmentActivity({
  activity,
  aid,
}: {
  activity: AptActivityType;
  aid: string;
}) {
  if (!aid || !activity) return;

  const { user } = getMe();
  let actorPerformingEvent: Actor;
  if (user?.ps) {
    actorPerformingEvent = MAP_PERSONA_TO_ACTOR_PREFIX[user?.ps];
  } else {
    actorPerformingEvent = user["is-d-s"] ? Actor.STAFF : Actor.DOCTOR;
  }

  if (!whiteListedActivityTypes.has(activity)) {
    // mixpanel for the ones that we haven't white listed. and for the ones we have that goes in FS
    getB().track(activity, {
      aid,
      actor: actorPerformingEvent,
      actor_oid: user.oid,
      attribute: "dr-web",
      actor_name: user.fn,
    });
    return;
  }

  const appointmentActivityDataMap: firestoreAppointmentActivityDataObject = {
    event: activity,
    actor_id: user.oid,
    client_id: SourcePlatform.WEB,
    actor_role: actorPerformingEvent,
    created_at: getB().firestore.serverTimestamp(),
    expires_at: makeFirestoreTTL_For6months(),
    actor_name: `${user.fn}`,
  };
  getB().recordAppointmentActivityInFireStore.recordAppointmentActivityInFS(
    appointmentActivityDataMap,
    aid
  );
}

export enum AptActivityType {
  CREATED = "CREATED",
  VISIT_STARTED = "VISIT_STARTED",
  VISIT_ENDED = "VISIT_ENDED",
  VISIT_PARKED = "VISIT_PARKED",
  VISIT_CANCELLED = "VISIT_CANCELLED",
  VISIT_RESCHEDULED = "VISIT_RESCHEDULED",
  VISIT_CHECKED_IN = "VISIT_CHECKED_IN",
  FOLLOWUP_CHECKED_IN = "FOLLOWUP_CHECKED_IN",
  MARKED_NOSHOW = "MARKED_NOSHOW",
  MARKED_ABORTED = "MARKED_ABORTED",
  MARKED_PARKABLE = "MARKED_PARKABLE",
  MSG_SA = "MSG_SA",
  APT_REMINDER_SENT = "APT_REMINDER_SENT",
  VISIT_ARCHIVED = "VISIT_ARCHIVED",
  APT_SYNC = "APT_SYNC",
  REQ_CB = "REQ_CB",
  SA_UPDATED = "SA_UPDATED",
  APT_MUTLI_TAG = "APT_MUTLI_TAG",
  APT_TAG_ADDED = "APT_TAG_ADDED",
  APT_TAG_DELETED = "APT_TAG_DELETED",
  APT_PAYMENT_UPDATED = "APT_PAYMENT_UPDATED",
  PREPAY_FAILED = "PREPAY_FAILED",
  TELE_STATUS = "TELE_STATUS",
  FOLLOWUP_DATE_ADDED = "FOLLOWUP_DATE_ADDED",
  FOLLOWUP_MESSAGE_UPDATE = "FOLLOWUP_MESSAGE_UPDATE",
  FOLLOWUP_REMINDER_SENT = "FOLLOWUP_REMINDER_SENT",
  RESCHEDULE_CREATED = "RESCHEDULE_CREATED",
  REQUESTED_APT_CHECKED_IN = "REQUESTED_APT_CHECKED_IN",
  RECEIPT_CREATED = "RECEIPT_CREATED",
  RECEIPT_UPDATED = "RECEIPT_UPDATED",
  RECEIPT_DELETED = "RECEIPT_DELETED",
  ASSIGN_DOCTOR = "ASSIGN_DOCTOR",
  SUBMIT_CUSTOM_FIELD = "SUBMIT_CUSTOM_FIELD",
  SUBMIT_FIELD = "SUBMIT_FIELD",
}

enum SourcePlatform {
  // ANDROID = "doc-android",
  WEB = "doc-web",
  // IOS = "doc-ios",
  // IPAD = "doc-iPad",
}

export enum Actor {
  DOCTOR = "DOCTOR",
  STAFF = "STAFF",
  SYSTEM = "SYSTEM",
  PATIENT = "PATIENT",
  ADMIN = "ADMIN",
}

export const MAP_PERSONA_TO_ACTOR_PREFIX: {
  [k: string]: Actor;
} = {
  S: Actor.STAFF,
  D: Actor.DOCTOR,
  AD: Actor.ADMIN,
};
